import axios from "axios";

const API = process.env.REACT_APP_API_ROOT;

/**
 * The Drive endpoints (`/api/admin/drive/*`). Each call resolves to the
 * response's `data`, and throws with the server's own message — a 403 says
 * which permission is missing, and "changed by someone else" needs to reach
 * the person as written.
 */
const call = async (request) => {
  try {
    const { data } = await request;
    if (data?.status === false) throw new Error(data.error || "Something went wrong");
    return data?.data;
  } catch (error) {
    throw new Error(error?.response?.data?.error || error.message || "Something went wrong");
  }
};

export const driveApi = (token) => {
  const opts = { headers: { Authorization: `Bearer ${token}` } };
  return {
    folders: () => call(axios.get(`${API}/api/admin/drive/folders`, opts)),
    createFolder: (body) => call(axios.post(`${API}/api/admin/drive/folders`, body, opts)),
    updateFolder: (id, body) => call(axios.put(`${API}/api/admin/drive/folders/${id}`, body, opts)),
    deleteFolder: (id) => call(axios.delete(`${API}/api/admin/drive/folders/${id}`, opts)),

    items: (params) => call(axios.get(`${API}/api/admin/drive/items`, { ...opts, params })),
    createItem: (body) => call(axios.post(`${API}/api/admin/drive/items`, body, opts)),
    updateItem: (id, body) => call(axios.put(`${API}/api/admin/drive/items/${id}`, body, opts)),
    deleteItem: (id) => call(axios.delete(`${API}/api/admin/drive/items/${id}`, opts)),

    versions: (id) => call(axios.get(`${API}/api/admin/drive/items/${id}/versions`, opts)),
    restore: (id, version) =>
      call(axios.post(`${API}/api/admin/drive/items/${id}/versions/${version}/restore`, {}, opts)),
  };
};

/** "17 Sep 2026, 2:46 pm" — the date and the time, since edits land same-day. */
export const formatWhen = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

/**
 * Copies text, falling back to a hidden textarea where the async clipboard
 * API is unavailable (an http:// staging host, an older browser).
 */
export const copyText = async (text) => {
  if (navigator.clipboard?.writeText && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const area = document.createElement("textarea");
  area.value = text;
  area.setAttribute("readonly", "");
  area.style.position = "fixed";
  area.style.opacity = "0";
  document.body.appendChild(area);
  area.select();
  const ok = document.execCommand("copy");
  document.body.removeChild(area);
  if (!ok) throw new Error("Copy failed");
};
